import { defineMessage } from 'react-intl';

export const buttonI18n = {
  addFamilyMember: defineMessage({
    id: 'button.add-family-member',
    defaultMessage: 'Add family member'
  }),
  addPaymentMethod: defineMessage({
    id: 'button.add-payment-method',
    defaultMessage: 'Add payment method'
  }),
  bookNow: defineMessage({
    id: 'button.book-now',
    defaultMessage: 'Book now'
  }),
  confirmAndPay: defineMessage({
    id: 'button.confirm-and-pay',
    defaultMessage: 'Confirm and pay'
  }),
  keepMyBooking: defineMessage({
    id: 'button.keep-my-booking',
    defaultMessage: 'Keep my booking'
  }),
  leaveComment: defineMessage({
    id: 'button.leave-comment',
    defaultMessage: 'Leave comment'
  }),
  linkUser: defineMessage({
    id: 'button.link-user',
    defaultMessage: 'Link user'
  }),
  logIn: defineMessage({
    id: 'button.log-in',
    defaultMessage: 'Log in'
  }),
  logOut: defineMessage({
    id: 'button.log-out',
    defaultMessage: 'Sign out'
  }),
  proceedToOnlineLesson: defineMessage({
    id: 'button.proceed-to-online-lesson',
    defaultMessage: 'Proceed to online lesson'
  }),
  requestBookingCancellation: defineMessage({
    id: 'button.request-booking-cancellation',
    defaultMessage: 'Request cancellation'
  }),
  sendRequest: defineMessage({
    id: 'button.send-request',
    defaultMessage: 'Send request'
  }),
  showMoreDates: defineMessage({
    id: 'button.show-more-dates',
    defaultMessage: 'Show more dates'
  }),
  showAllNumReviews: defineMessage({
    id: 'button.show-all-num-reviews',
    defaultMessage: 'Show all {num, number} reviews'
  }),
  signUp: defineMessage({
    id: 'button.sign-up',
    defaultMessage: 'Sign up'
  }),
  writeReview: defineMessage({
    id: 'button.write-review',
    defaultMessage: 'Write a review'
  }),
  writeReviewShort: defineMessage({
    id: 'button.write-review.short',
    defaultMessage: 'Review'
  })
};
